class CustomEvents {
  static click(_body, _target, _function) {
    let body = _body;
    let target = _target;
    if (body === undefined || body === null) {
      body = document;
    }
    body.addEventListener(
      "click",
      function (event) {
        const target = event.target.closest(_target);
        if (target) {
          _function(event);
        }
      },
      false,
    );
  }

  static change(_body, _target, _function) {
    let body = _body;
    let target = _target;
    if (body == undefined) {
      body = document;
    }
    body.addEventListener(
      "change",
      function (event) {
        if (!event.target.matches(target)) return;
        _function(event);
      },
      false,
    );
  }

  static keypress(_body, _target, _function) {
    let body = _body;
    let target = _target;
    if (body == undefined) {
      body = document;
    }
    body.addEventListener(
      "keypress",
      function (event) {
        if (!event.target.matches(target)) return;
        _function(event);
      },
      false,
    );
  }

  static doubleClick(_body, _target, _function) {
    let body = _body;
    let target = _target;
    if (body == undefined) {
      body = document;
    }
    body.addEventListener(
      "dblclick",
      function (event) {
        if (!event.target.matches(target)) return;
        _function(event);
      },
      false,
    );
  }

  static blur(_body, _target, _function) {
    let body = _body;
    let target = _target;
    if (body == undefined) {
      body = document;
    }
    body.addEventListener("blur", (event) => {
      if (!event.target.matches(target)) return;
      _function(event);
    });
  }

  static simulateClick(elem) {
    let evt = new MouseEvent("click", {
      bubbles: true,
      cancelable: true,
      view: window,
    });
    // If cancelled, don't dispatch our event
    let canceled = !elem.dispatchEvent(evt);
  }

  static hasClass = (element, cls) => {
    return (" " + element.className + " ").indexOf(" " + cls + " ") > -1;
  };

  static validateEmail(email) {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  static validatePassword(password) {
    const re = new RegExp(
      "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$",
    );
    return re.test(password);
  }

  static getMeta = (metaName) => {
    const metas = document.getElementsByTagName("meta");
    for (let i = 0; i < metas.length; i++) {
      if (metas[i].getAttribute("name") === metaName) {
        return metas[i].getAttribute("content");
      }
    }
    return "";
  };
  static request = (url, method, data, successCallback, fail) => {
    const _self = this;
    fetch(url, {
      method: method,
      body: data,
      headers: {
        Accept: "application/json",
        "X-CSRF-Token": this.getMeta("csrf-token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then(successCallback)
      .catch(fail);
  };
}

window.CustomEvents = CustomEvents;
